module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("chapter 4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/23.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_vm._v("1990 METALLIC GREEN FORD TAURUS")])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("Joaquin stared out")]), _vm._v(" the car window, listening to a mix tape on his run-down Walkman. The sun, suspended in a bright cloudless sky, swept the highway with a harsh, blinding light. He found it hard to keep from blinking.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He maxed the volume.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another sunny day, he thought, squinting at the passing vehicles through the insect graveyard on the windshield.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The sun had shone this way before. It would shine this way again. A forgettable day, an anonymous day.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But Joaquin welcomed this.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He wanted this day—this trip—to be over as soon as possible. He wanted to return to Mexico unaffected, unmarked. So much had gone right in the last few weeks: things that had never gone right for him before. Things that made a difference. Things that made him happy.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He prayed that nothing on this trip would change that.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A lot of fifteen-year-olds say prayers like this. They’re rarely answered.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This one wouldn’t be either.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Up to this point, the trip from Mexico City with his parents "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" been uneventful. Airport to airport with no delay. Through customs without a hitch. Their luggage among the first off the carousel. And there wasn’t even a line at the car-rental place.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They grabbed a quick bite at a roadside steak joint, and then headed for downtown Houston and their hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Joaquin hoped it would continue this way. Then his father opened his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you say we take a tour through the skyline district before hitting the hotel, Joaquin? I really want you to see that Dubuffet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Joaquin cringed. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dad and his art lessons")]), _vm._v(". Why was it that adults always wanted to teach you boring stuff?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Dad, I’m actually kinda tired,” Joaquin said, hoping that would be enough.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It wasn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“This Dubuffet changed my life. You’re gonna look at it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Joaquin sighed, resigned to his fate.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At fifteen, the idea of a family trip felt ludicrous to him. His differences with his parents, more now than ever before, seemed as vast and impassable as the empty, silent reaches of outer space.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His father tried to nurture in him a taste for modern art, but Joaquin never paid much attention. He had his own ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He flipped the tape and hit play. The mix of punk, metal, classic rock, and electronic music crushed reality—hurtling him into a world of aural bliss.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As Tangerine Dream’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Phaedra")]), _vm._v(" came on, his father stopped the car in front of 1100 Louisiana Street. Joaquin looked up and saw Dubuffet’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monument au Fantôme")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Without a word, he got out of the car and walked up to the sculpture. Strange irregular shapes outlined in thick black lines, suggesting human and animal forms. Christopher Franke’s Moog synthesizer caressed these irregular forms while the amber light of sunset gentled against the rough edges.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He was captivated by the sculpture. He moved into the center of the piece and sat cross-legged on the ground. He looked up, watching clouds roll overhead through Dubuffet’s embracing forms.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page26"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As he unhurriedly slouched back to the car, he felt a strange sensation, as if he’d spied the corner of some immense, hidden object. It sent a tiny bat-squeak of recognition through his body. Had his father’s lessons finally sunk in? If true, he wouldn’t let on…ever.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What do you think about Dubuffet?” asked his father.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Like him. Already knew his work,” mumbled Joaquin, and then he was silent.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Those were the last words Joaquin spoke till they arrived at the hotel. His parents were accustomed to these long silences. Joaquin often milked the silences, hoping they might read his teenage angst act as something more profound. Not today. He wasn’t thinking about them. Something else occupied his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Her name was Claudia Guerrero.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Considered the prettiest girl in school, she had filled his thoughts for months. Even before they started dating. They had intended to spend the weekend together…unsupervised. Every teenage boy’s dream: a weekend, alone, with the hottest girl in school. But this trip had blown that out of the water.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He tried to convince his parents to let him stay. But they wouldn’t budge.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Your grandmother is very sick. Who knows how much more time she has?” his mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Just the same, he didn’t know how long his relationship with Claudia would last, and to lose that precious time was devastating—doubly so because Claudia’s parents had kept her under close watch after finding a pile of Polaroids of a dick (Ernesto Meyer’s, they later learned) in their daughter’s mouth. It didn’t help when she explained that all of her friends had pictures just like those.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Joaquin’s argument did gain him something. His mother agreed to buy him an inexpensive electric guitar. The bribe worked. He stopped resisting the trip.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Immediately afterward, he regretted it. Why did he give in for so little? He should have insisted on a vintage ’62 Stratocaster. Or at least a Fender.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page27"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At the hotel, while his parents were out, Joaquin called Claudia. She picked up on the second ring.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He immediately launched into a rant. He told her that he was fed up, that he hated the food and the hotel. There was nothing that disgusted him more than hospitals; he would have to spend the entire next day in one. When he tried to tell her about the Dubuffet sculpture, he couldn’t find the right words to describe it, and ended up changing the subject. He was too embarrassed to tell her that he loved her or missed her, or that he wanted to touch her breasts, so he said good-bye with a cold ciao.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Ciao”—excellent move, he thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The conversation frustrated him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For a while, he lay in bed and watched TV. He wasn’t enjoying it at all. He couldn’t believe the caravan of imbeciles that paraded around, submitting to the most ridiculous stunts imaginable. He fell asleep numbly contemplating the decomposing wasteland of late-night television.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The next day, after a bland hotel breakfast, they got into the rented Ford and went to the hospital. Joaquin listened to the Dead Kennedys.")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Efficiency and progress is ours once more")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Now that we have the Neutron bomb")])]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s nice and quick and clean and gets things done.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His parents listened to the radio. Some talk program. Under Biafra’s growl, he heard a voice say: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You really should listen.")]), _vm._v(" He rewound the tape and played it again. It wasn’t there. Weird, he thought, must have been my imagination. But somewhere deep in his brain, nestled in the limbic system, a preternatural fear arose.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Danger was near.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b829e182","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter04.vue
// module id = 84
// module chunks = 0